<template>
    <div>
        
    </div>
</template>

<script>
import  router from '@/router/index.js';
export default {
    name: 'TheIndex',
    beforeCreate() {
        router.push({ path: '/admin/dashboard' })
    }
}
</script>